module.exports = __webpack_public_path__ + "img/teams_squads.e0def737.png";